import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Stack, Tooltip, Avatar as Image } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  useBoardUsers,
  useGetBoardUser,
} from "../../../../../utils/reactQuery/users";
import UsersIcon from "../../../../../styles/svg/users-icon.svg";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { AddUserDialog } from "./components/AddUserDialog";
import { TooltipName } from "../../../../../utils/Enums";
import AddUsers from "./AddUsers";
import AvatarGroupList from "./components/AvatarGroupList";
import UsersList from "./components/UsersList";
import MobileView from "./components/MobileView";
import RemoveUser from "./RemoveUser";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";

function Users({
  boardName,
  boardId,
  ownerId,
  showAddUser = true,
  colabratorBoardName,
  isColabrotar = false,
  cardCollabrator,
  handleRemoveColabrotor,
  handleAddColabrotor,
  assigneeUserId = null,
  canAddCollaborator,
  mobileFilterSelectedUser = [],
  handleMobileFilterUser = () => {},
  setDrawerClose = () => {},
}) {
  const { id } = useBoardIdByKey();
  const [users, setUsers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);
  const isMobile = useResponsive("down", "md");
  const { data } = useBoardUsers(id || boardId);
  const [boardUser, setBoardUser] = useState([]);
  const [openEditUserDialog, setOpenEditUserDialog] = useState(null);
  const { data: userData } = useGetBoardUser(id, openEditUserDialog);

  const [selectedUserSearch, updateSearchParams, removeSearchParam] =
    useCustomSearchParams("search");
  const selectedUsers = useMemo(
    () => selectedUserSearch?.split(","),
    [selectedUserSearch]
  );

  useEffect(() => {
    setUsers(
      isColabrotar
        ? cardCollabrator || []
        : data?.data?.data?.responseData || []
    );
  }, [data, cardCollabrator, isColabrotar]);

  useEffect(() => {
    if (isColabrotar && data) {
      setBoardUser(data?.data?.data?.responseData);
    }
  }, [data, isColabrotar]);

  const closeUserList = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const filterUserById = useCallback(
    (userId) => {
      if (!isColabrotar) {
        let selected = selectedUsers || [];
        if (selected?.includes(String(userId))) {
          selected = selected?.filter((id) => id !== String(userId));
        } else {
          selected?.push(userId);
        }
        if (
          selectedUsers?.[0] === String(userId) &&
          selectedUsers?.length === 1
        ) {
          removeSearchParam("search");
        } else {
          updateSearchParams("search", selected?.join(","));
        }
      }
    },
    [isColabrotar, selectedUsers, removeSearchParam, updateSearchParams]
  );

  const removeSelectedUser = useCallback(() => {
    removeSearchParam("search");
  }, [removeSearchParam]);

  const handleAnchorClick = useCallback((event) => {
    setAnchorEl(event?.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setOpenEditUserDialog(null);
  }, []);

  return (
    <>
      {openEditUserDialog && userData && (
        <AddUserDialog
          boardName={boardName}
          open={openEditUserDialog}
          onClose={handleClose}
          users={users}
          isUpdateUser={true}
          currentUser={userData?.data?.data?.responseData}
        />
      )}

      <Stack
        className={isColabrotar ? "align-items-start" : "align-items-center"}
      >
        <div
          className={`d-flex justify-content-center align-items-center ${
            isMobile ? "mobile-users-list-updated" : ""
          }`}
        >
          {/* {!isMobile && ( */}
            <>
              <AvatarGroupList
                users={users}
                setAnchorEl={setAnchorEl}
                isColabrotar={isColabrotar}
                selectedUsers={selectedUsers}
                filterUserById={
                  isMobile ? handleMobileFilterUser : filterUserById
                }
                boardOwnerId={boardName?.data?.responseData?.owner_user_id}
              />

              <Tooltip
                title={
                  isColabrotar
                    ? TooltipName.CARD_DETAIL.COLLABRATOR_LIST
                    : TooltipName.BOARD_PAGE.USER_LIST
                }
              >
                <Image
                  onClick={handleAnchorClick}
                  src={UsersIcon}
                  key="avatar-12343"
                  className="header-avatar cursor-pointer"
                >
                  AS
                </Image>
              </Tooltip>
            </>
          {/* )} */}

          {users.length > 0 && (
            <UsersList
              anchorEl={anchorEl}
              open={open}
              closeUserList={closeUserList}
              users={users}
              isColabrotar={isColabrotar}
              ownerId={ownerId}
              filterUserById={
                isMobile ? handleMobileFilterUser : filterUserById
              }
              selectedUsers={
                isMobile ? mobileFilterSelectedUser : selectedUsers
              }
              removeSelectedUser={removeSelectedUser}
              handleRemoveColabrotor={handleRemoveColabrotor}
              setOpenEditUserDialog={setOpenEditUserDialog}
              boardName={boardName}
              setDrawerClose={setDrawerClose}
            />
          )}

          {
          // !isMobile && 
          showAddUser && (
            <AddUsers
              boardName={boardName}
              ownerId={ownerId}
              users={boardUser}
              colabratorBoardName={colabratorBoardName}
              isColabrotar={isColabrotar}
              handleAddColabrotor={handleAddColabrotor}
              assigneeUserId={assigneeUserId}
              canAddCollaborator={canAddCollaborator}
            />
          )}
        </div>
      </Stack>
    </>
  );
}

export default Users;
